import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import {toast, ToastContainer} from "react-toastify";
import AuthContext from "../../components/shared/AuthContext";
import OrgContext from "../../organisation/OrgContext";
import {API} from "../../services/api";

const ClientDetails = (props) => {
    const [t, i18n] = useTranslation();
    const [display, setDisplay] = useState(false);
    const [displayErrors, setDisplayErrors] = useState('none');
    const {user, logout} = useContext(AuthContext);
    const navigate = useNavigate();
    const { organisation, changeOrg } = useContext(OrgContext);

    const [client_id, setClientId] = useState(null);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');
    const [ice,setIce] = useState('');
    const [idFiscal,setIdFiscal] = useState('');

    const [facAdCountry, setFacAdCountry] = useState('');
    const [facAdCity, setFacAdCity] = useState('');
    const [facAdCodePostal, setFacAdCodePostal] = useState('');
    const [facAdOthers, setFacAdOthers] = useState('');

    const [livAdCity, setLivAdCity] = useState('');
    const [livAdCountry, setLivAdCountry] = useState('');
    const [livAdCodePostal, setLivAdCodePostal] = useState('');
    const [livAdOthers, setLivAdOthers] = useState('');
    const [account, setAccount] = useState('');

    useEffect(()=> {
        if(props.client){
            let client = props.client;
            setClientId(client?.id);
            setName(client?.name);
            setLastName(client?.lastName)
            setPhoneNumber(client?.phoneNumber)
            setCompanyName(client?.companyName)
            setEmail(client?.email)
            setWebSite(client?.website)
            setIce(client?.ice)
            setIdFiscal(client?.idFiscal)
            setAccount(client?.account.code)
            setFacAdCountry(client?.addressFacCountry)
            setFacAdCity(client?.addressFacCity)
            setFacAdCodePostal(client?.addressFacCodePostal)
            setFacAdOthers(client?.addressFacOthers)
            setLivAdCountry(client?.addressLivCountry && client?.addressLivCountry ? client?.addressLivCountry : client?.addressFacCountry)
            setLivAdCity(client?.addressLivCity && client?.addressLivCity ? client?.addressLivCity : client?.addressFacCity)
            setLivAdCodePostal(client?.addressLivCodePostal && client?.addressLivCodePostal ? client?.addressLivCodePostal : client?.addressFacCodePostal)
            setLivAdOthers(client?.addressLivOthers && client?.addressLivOthers ? client?.addressLivOthers : client?.addressFacOthers)
        }
    }, []);

    const saveClient = async (client) => {
        const response = await API.post('/client/edit', client).then(res => {
            if(props.ocr){
                props.afterSave(client);
            }else{
                Swal.fire(
                    t('Le client a été ajouter avec succès'),
                    t(''),
                    'success'
                );
                navigate(-1)
            }

        }).catch((error) => console.log(error));
    }
    const Save = () => {
        if (name.length === 0 || email.length === 0 || companyName.length === 0 || phoneNumber.length === 0) {
            toast.error('Merci de verifier les champs obligatoire !', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            const preparedObject = {
                id: client_id,
                name: name,
                lastName: lastName === null ? "" : lastName,
                type: props.type,
                email: email,
                companyName: companyName,
                phoneNumber: phoneNumber,
                website: webSite,
                addressFacCountry: facAdCountry,
                addressFacCity: facAdCity,
                addressFacCodePostal: facAdCodePostal,
                addressFacOthers: facAdOthers,
                addressLivCountry: livAdCountry,
                addressLivCity: livAdCity,
                addressLivCodePostal: livAdCodePostal,
                addressLivOthers: livAdOthers,
                user_id: user.id
                ,ice: ice
                ,idFiscal: idFiscal
                ,organization_id: organisation.id
            };
            saveClient(preparedObject);
        }
    };
    return (
        <>
            <ToastContainer/>

            <div class="row">
                <div class="col-xl-4">
                    <div class="card">
                        <div class="card-header">

                        </div>
                        <div class="card-body">
                            <div class="text-center chat-image mb-5">

                                <div class="main-chat-msg-name">
                                    <h5 class="mb-1 text-dark fw-semibold">{companyName}</h5>
                                    <p class="text-muted mt-0 mb-0 pt-0 fs-13">{name}</p>
                                </div>
                            </div>


                        </div>

                    </div>
                    <div class="card panel-theme">
                        <div class="card-header">
                            <div class="float-start">
                                <h3 class="card-title">Contact principal</h3>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="card-body no-padding">
                            <ul class="list-group no-margin">
                                <li className="list-group-item d-flex ps-3">
                                    <div class="social social-profile-buttons me-2">
                                        <a className="social-icon text-primary" href=""><i class="fe fe-mail"></i></a>
                                    </div>
                                    <span class="my-auto">{email}</span>
                                </li>
                                <li className="list-group-item d-flex ps-3">
                                    <div class="social social-profile-buttons me-2">
                                        <a className="social-icon text-primary" href=""><i class="fe fe-globe"></i></a>
                                    </div>
                                    <span class="my-auto">{webSite}</span>
                                </li>
                                <li className="list-group-item d-flex ps-3">
                                    <div class="social social-profile-buttons me-2">
                                        <a className="social-icon text-primary" href=""><i class="fe fe-phone"></i></a>
                                    </div>
                                    <span class="my-auto">{phoneNumber}</span>
                                </li>
                                <li className="list-group-item d-flex ps-3">
                                    <div class="social social-profile-buttons me-2">
                                        L'identifiant Commun de l'Entreprise :
                                    </div>
                                    <span class="my-auto">{ice}</span>
                                </li>
                                <li className="list-group-item d-flex ps-3">
                                    <div class="social social-profile-buttons me-2">
                                        L'identifiant Fiscal de L'entreprise :
                                    </div>
                                    <span class="my-auto">{idFiscal}</span>
                                </li>
                                <li className="list-group-item d-flex ps-3">
                                    <div class="social social-profile-buttons me-2">
                                        Sous Comptes :
                                    </div>
                                    <span class="my-auto">{account}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8">


                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">ADRESSE DE FACTURATION
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Pays / Région</span><input
                                    type="text" className="form-control" value={facAdCountry} contentEditable={false}/></div>
                            </div>

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Ville</span><input
                                    type="text" className="form-control" value={facAdCity} contentEditable={false}/></div>
                            </div>

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Code Postal</span><input
                                    type="text" className="form-control" value={facAdCodePostal} contentEditable={false}/></div>
                            </div>

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Adresse / Rue </span><input
                                    type="text" className="form-control" value={facAdOthers} contentEditable={false}/></div>
                            </div>
                        </div>
                    </div>
                    <div class="card" style={{display: (display) ? 'none' : 'block'}}>
                        <div class="card-header">
                            <div class="card-title">ADRESSE DE LIVRAISON

                            </div>
                        </div>
                        <div class="card-body">

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Pays / Région</span><input
                                    type="text" className="form-control" value={livAdCountry} contentEditable={false}/></div>
                            </div>

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Ville</span><input
                                    type="text" className="form-control" value={livAdCity} contentEditable={false}/></div>
                            </div>

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Code Postal</span><input
                                    type="text" className="form-control" value={livAdCodePostal} contentEditable={false}/></div>
                            </div>

                            <div class="form-group">
                                <div class="input-group mb-3"><span class="input-group-text">Adresse / Rue </span><input
                                    type="text" className="form-control" value={livAdOthers} contentEditable={false}/></div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default ClientDetails;